import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Small } from '@dbk/ui-text';
import TitleHeader from './title-header';
import Button from '@dbk/ui-buttons';
import { TextInput } from 'react-native';
import styles from './alert-management.styles';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from '@dbk/ui-modal';

class AlertManagement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobileChecked: false,
      isWebChecked: false,
      isSystemDowntimeChecked: false,
      isAlertsChecked: false,
      isImportantMessagesChecked: false,
      isTextAreaDisabled: false,
      // comments:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing aasadasdasdadadasdasdadasdasdasdasda asdadasdasdasda .",
      comments: '',
      isAlwaysDisplayMessage: false,
      setErrorMessage: '',
      isFromDate: moment(),
      isToDate: moment(),
      isDisabled: true,
      isActivatedMessage: false,
      marqueId: 0,
      modal: false,
    };
    // this.handleDatePickerChange = this.handleDatePickerChange.bind(this);
    this.closeBlurModel = this.closeBlurModel.bind(this);
  }

  closeBlurModel() {
    this.setState({ modal: false });
  }

  handleAcceptPublish() {
    const {
      i18n: { messages },
    } = this.props;
    let configType = '',
      channel = '',
      flgenable = '',
      permanentFlag = 1;
    if (
      this.state.isMobileChecked === true &&
      this.state.isWebChecked === true
    ) {
      channel = 'all';
    } else {
      if (this.state.isMobileChecked === true) {
        channel = 'mobile';
      } else {
        channel = 'web';
      }
    }
    if (this.state.isSystemDowntimeChecked === true) {
      configType = messages['app.common.marque.downTime'];
    }
    if (this.state.isAlertsChecked === true) {
      configType = messages['app.common.marque.alerts'];
    }
    if (this.state.isImportantMessagesChecked === true) {
      configType = messages['app.common.marque.impMsg'];
    }
    if (this.state.isActivatedMessage === true) {
      flgenable = 'Y';
    } else {
      flgenable = 'N';
    }
    if (this.state.isAlwaysDisplayMessage === true) {
      permanentFlag = 2;
    }
    const saveAdminData = {
      configType: configType,
      channel: channel,
      configKeyValue: this.state.comments,
      permanentFlag: permanentFlag,
      validFromDt: moment(this.state.isFromDate).format('YYYY-MM-DD HH:mm:ss'),
      validToDt: moment(this.state.isToDate).format('YYYY-MM-DD HH:mm:ss'),
      marqueId: this.state.marqueId,
      flgenable: flgenable,
    };
    // confirm("Do you really want to publish ??" );
    this.props.marque.saveMarqueData(saveAdminData);
  }

  componentWillMount() {
    this.handleDisable();
    const {
      marque: { editMarqueData },
    } = this.props;
    if (editMarqueData) {
      switch (editMarqueData.channel.toUpperCase()) {
        case 'MOBILE':
          this.setState({ isMobileChecked: true });
          break;
        case 'WEB':
          this.setState({ isWebChecked: true });
          break;
        case 'ALL':
          this.setState({ isWebChecked: true, isMobileChecked: true });
          break;
        default:
          this.setState({ isWebChecked: false, isMobileChecked: false });
          break;
      }

      switch (editMarqueData.configType.toUpperCase()) {
        case 'SYSTEM DOWNTIME':
          this.setState({ isSystemDowntimeChecked: true });
          break;
        case 'ALERT(S)':
          this.setState({ isAlertsChecked: true });
          break;
        case 'IMPORTANT MESSAGE(S)':
          this.setState({ isImportantMessagesChecked: true });
          break;
        default:
          this.setState({
            isSystemDowntimeChecked: false,
            isAlertsChecked: false,
            isImportantMessagesChecked: false,
          });
          break;
      }

      if (editMarqueData.flgenable.toUpperCase() === 'Y') {
        this.setState({ isActivatedMessage: true });
      } else {
        this.setState({ isActivatedMessage: false });
      }

      this.setState({
        comments: editMarqueData.configKeyValue,
        isDisabled: false,
        marqueId: editMarqueData.marqueId,
        isFromDate: moment(editMarqueData.validFromDt),
        isToDate: moment(editMarqueData.validToDt),
      });
    }
  }

  handleCancelPress() {
    this.props.marque.editMarque('');
    this.props.replacePage({ pathname: '/admin/alertlist' });
  }

  handlePublishPress() {
    const {
      i18n: { messages },
    } = this.props;
    if (
      (!this.state.isMobileChecked && !this.state.isWebChecked) ||
      (!this.state.isSystemDowntimeChecked &&
        !this.state.isAlertsChecked &&
        !this.state.isImportantMessagesChecked) ||
      this.state.comments.length == 0
    ) {
      // if(!this.state.isSystemDowntimeChecked && !this.state.isAlertsChecked && !this.state.isImportantMessagesChecked){
      // if(this.state.comments.length==0){
      this.setState({
        setErrorMessage: messages['app.common.marque.fillAllFields'],
      });
      return;
      // }
      // }
    }
    this.setState({ modal: true });
  }

  handleDisable() {
    if (
      this.state.isMobileChecked === false ||
      this.state.isWebChecked === false
    ) {
      this.setState({ isDisabled: true });
    } else {
      this.setState({ isDisabled: false });
    }
    this.setState({ setErrorMessage: '' });
  }

  handleChangeCheckbox(channel) {
    this.handleDisable();
    if (channel === 'mobile') {
      if (this.state.isMobileChecked === true) {
        this.setState({ isMobileChecked: false });
      } else {
        this.setState({ isMobileChecked: true });
      }
      if (this.state.isAlwaysDisplayMessage === true) {
        this.setState({ isDisabled: true });
      } else {
        this.setState({ isDisabled: false });
      }
    } else if (channel === 'web') {
      if (this.state.isWebChecked === true) {
        this.setState({ isWebChecked: false });
      } else {
        this.setState({ isWebChecked: true });
      }
      if (this.state.isAlwaysDisplayMessage === true) {
        this.setState({ isDisabled: true });
      } else {
        this.setState({ isDisabled: false });
      }
    }
    if (channel === 'alwaysDisplayMessage') {
      if (this.state.isAlwaysDisplayMessage === true) {
        this.setState({
          isAlwaysDisplayMessage: false,
          isToDate: this.state.isFromDate,
          isDisabled: false,
        });
      } else {
        this.setState({
          isAlwaysDisplayMessage: true,
          isToDate: moment('99991231', 'YYYYMMDD'),
          isDisabled: true,
        });
      }
    }
    if (channel === 'activateMessage') {
      if (this.state.isActivatedMessage === true) {
        this.setState({ isActivatedMessage: false });
      } else {
        this.setState({ isActivatedMessage: true });
      }
    }
    this.setState({ setErrorMessage: ' ' });
  }

  handleRadioChange(msgType) {
    if (msgType === 'systemdowntime') {
      this.setState({
        isSystemDowntimeChecked: true,
        isAlertsChecked: false,
        isImportantMessagesChecked: false,
      });
    } else if (msgType === 'alerts') {
      this.setState({
        isSystemDowntimeChecked: false,
        isAlertsChecked: true,
        isImportantMessagesChecked: false,
      });
    } else if (msgType === 'importantmessages') {
      this.setState({
        isSystemDowntimeChecked: false,
        isAlertsChecked: false,
        isImportantMessagesChecked: true,
      });
    }
    this.setState({ setErrorMessage: ' ' });
  }

  handleDatePickerChange(date, period) {
    if (period == 'start') {
      this.setState({ isFromDate: date, isToDate: date });
    } else if (period == 'end') {
      this.setState({ isToDate: date });
    }
  }

  renderAlertContent() {
    const { comments } = this.state;
    const {
      i18n: { messages },
    } = this.props;
    return (
      <div className="row small-12 large-12 pad-20">
        <div>
          <div>
            <Text secondary>{messages['app.common.marque.channels']}</Text>
            <Text style={{ color: '#f62929' }}>*</Text>
          </div>
          <div className="inputTypeButtons">
            <span className="inputTypeButtons-span">
              <input
                type="checkbox"
                checked={this.state.isMobileChecked}
                onChange={() => this.handleChangeCheckbox('mobile')}
              />
              <label />
              <Small secondary>
                {messages['app.common.marque.mobTabText']}
              </Small>
            </span>
            <span className="inputTypeButtons-span">
              <input
                type="checkbox"
                checked={this.state.isWebChecked}
                onChange={() => this.handleChangeCheckbox('web')}
              />
              <label />
              <Small secondary>{messages['app.common.marque.webText']}</Small>
            </span>
          </div>
        </div>
        <div className="margin-top-15">
          <div>
            <Text secondary>{messages['app.common.marque.startEndText']}</Text>
          </div>
          <div className="margin-top-5">
            <span className="dateField">
              <Small secondary>{messages['app.common.marque.startText']}</Small>
              <Text style={{ color: '#f62929' }}>*</Text>
              <Small secondary> :</Small>
              <DatePicker
                selected={this.state.isFromDate}
                onChange={(date) => this.handleDatePickerChange(date, 'start')}
                minDate={moment()}
                showTimeSelect
                disabled={this.state.isDisabled}
                timeIntervals={30}
                dateFormat="LLL"
                monthsShown={1}
              />
            </span>
            <span className="dateField">
              <Small secondary>{messages['app.common.marque.endText']}</Small>
              <Text style={{ color: '#f62929' }}>*</Text>
              <Small secondary> :</Small>
              <DatePicker
                selected={this.state.isToDate}
                onChange={(date) => this.handleDatePickerChange(date, 'end')}
                showTimeSelect
                disabled={this.state.isDisabled}
                minDate={moment(this.state.isFromDate)}
                timeIntervals={30}
                dateFormat="LLL"
                monthsShown={1}
              />
            </span>
            <span className="inputTypeButtons">
              <span className="inputTypeButtons-span">
                <input
                  type="checkbox"
                  checked={this.state.isAlwaysDisplayMessage}
                  onChange={() =>
                    this.handleChangeCheckbox('alwaysDisplayMessage')
                  }
                />
                <label />
                <Small secondary>
                  {messages['app.common.marque.alwaysDisMsg']}
                </Small>
              </span>
            </span>
          </div>
        </div>
        <div className="margin-top-15">
          <div>
            <Text secondary>{messages['app.common.marque.msgType']}</Text>
            <Text style={{ color: '#f62929' }}>*</Text>
            <Small secondary> :</Small>
          </div>
          <div className="inputTypeButtons">
            <span className="inputTypeButtons-span">
              <input
                type="radio"
                checked={this.state.isSystemDowntimeChecked}
                onChange={() => this.handleRadioChange('systemdowntime')}
                id="systemdowntime"
              />
              <label />
              <Small secondary>{messages['app.common.marque.downTime']}</Small>
            </span>
            <span className="inputTypeButtons-span">
              <input
                type="radio"
                checked={this.state.isAlertsChecked}
                onChange={() => this.handleRadioChange('alerts')}
                id="alerts"
              />
              <label />
              <Small secondary>{messages['app.common.marque.alerts']}</Small>
            </span>
            <span className="inputTypeButtons-span">
              <input
                type="radio"
                checked={this.state.isImportantMessagesChecked}
                onChange={() => this.handleRadioChange('importantmessages')}
                id="importantmessages"
              />
              <label />
              <Small secondary>{messages['app.common.marque.impMsg']}</Small>
            </span>
          </div>
          <div className="inputTypeButtons">
            <TextInput
              multiline={true}
              numberOfLines={5}
              maxLength={1000}
              spellCheck="false"
              style={styles.textInput}
              className="textInputStyle"
              onChangeText={(comments) => this.handleComments(comments)}
              value={comments}
              placeholder={messages['app.common.marque.enterMsg']}
            />
            {comments.length == 0 ? (
              <div className="characterLimit">
                <Small secondary>
                  {messages['app.common.marque.max100character']}
                </Small>
              </div>
            ) : (
              <div className="characterLimit">
                <Small secondary>
                  {1000 - comments.length}{' '}
                  {messages['app.common.marque.characterLeft']}
                </Small>
              </div>
            )}
          </div>
        </div>
        <div>
          <span className="inputTypeButtons">
            <span className="inputTypeButtons-span">
              <input
                type="checkbox"
                checked={this.state.isActivatedMessage}
                onChange={() => this.handleChangeCheckbox('activateMessage')}
              />
              <label />
              <Small secondary>
                {messages['app.common.marque.activateMsg']}
              </Small>
            </span>
          </span>
        </div>
        <div id={this.state.setErrorMessage} className="errorColor">
          {this.state.setErrorMessage}
        </div>
        <div className="create-alert-buttons margin-top-15">
          <span
            className="create-alert-buttons-span"
            onClick={() => this.handleCancelPress()}
          >
            {messages['app.profile.changeLanguage.cancelText']}
          </span>
          <span className="margin-left-15 margin-right-15">
            <Button size="small" onClick={() => this.handlePublishPress()}>
              {messages['app.common.marque.publish']}
            </Button>
          </span>
        </div>
      </div>
    );
  }

  handleComments(comments) {
    this.setState({ comments });
    if (comments.length != 0) {
      this.setState({ setErrorMessage: '' });
    }
  }

  confirmScreen() {
    const {
      i18n: { messages },
    } = this.props;
    return (
      <div className="timeout-modal">
        <div className="row">
          <div className="small-12 text-center">
            <div className="callout">
              <h2>{messages['app.common.marque.publishMsg']} </h2>
              <div>{messages['app.common.marque.confirmPublishMsg']}</div>
              <div className="row">
                <div className="column small-push-3 small-6 pad-top-20">
                  <div className="row">
                    <div className="column small-6">
                      <Button
                        id="resetInactiveTimeout"
                        onClick={() => this.handleAcceptPublish()}
                      >
                        {messages['app.common.alert.yes']}
                      </Button>
                    </div>
                    <div className="column small-6">
                      <Button
                        id="logoutStopTimers"
                        onClick={() => this.closeBlurModel()}
                      >
                        {messages['app.common.alert.no']}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="profile-container">
        <div className="row small-12 large-10">
          <div className="callout module border-none">
            <TitleHeader />
            {this.renderAlertContent()}
            {this.state.modal && (
              <Modal
                isActive={this.state.modal}
                onClose={this.closeBlurModel}
                content={this.confirmScreen()}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    replacePage: { $call: 'ui.history.replace' },
    marque: {
      editMarqueData: true,
      editMarque: { $call: 'editMarque' },
      saveMarqueData: { $call: 'saveMarqueData' },
    },
    i18n: {
      messages: true,
    },
  },
})(AlertManagement);
